import { styled } from "@mui/material/styles";
import MuiAvatar from "@mui/material/Avatar";

export const CustomAvatar = styled(MuiAvatar)((props) => ({
    backgroundColor: "black", 
    borderRadius: "5px",
    fontSize: "45px", 
    width: 50, 
    height: 50
}));